module.exports = __webpack_public_path__ + "img/no-code-bulk-img.39cd0680.png";